import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";

import { PageLayout, PageHeader } from "../components/layout";
import { Loading } from "../components";
import RCAlertForm from "./components/RCAlertForm";
import "./rc-buy-alerts-page.scss";

const RCAlertCreate = () => {
  const history = useHistory();
  const { baseProductId } = useParams();
  const [product, setProduct] = useState();

  useEffect(() => {
    if (baseProductId === "new" || !baseProductId) {
      setProduct({});
      return;
    }

    let cancelled = false;
    axios.get(`/api/products/${baseProductId}`).then(({ data }) => {
      if (!cancelled) setProduct(data);
    });
    return () => {
      cancelled = true;
    };
  }, [baseProductId]);

  return (
    <PageLayout className="rc-buy-alerts-page">
      <PageHeader
        title="New Buy Alert"
        description="Search for a product and set your budget, filters, and notification preferences."
        backTo="/alerts"
      />

      <div className="rc-bap__form-wrap">
        {baseProductId && !product ? (
          <Loading type="loading" showText={false} />
        ) : (
          <RCAlertForm
            alert={{ product }}
            editableProduct
            afterSubmit={() => history.push("/alerts")}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default RCAlertCreate;
